<template>
  <StickyTable class="course-ranking-table" :header="header" :data="data" :loading="busy">
    <template #header>
      <tr>
        <Cell th horizontal vertical class="name">{{ header.courseName }}</Cell>
        <Cell th vertical>{{ header.rank }}</Cell>
        <Cell th vertical>{{ header.rate }}</Cell>
        <Cell th vertical>{{ header.sumQty }}</Cell>
        <Cell th vertical>{{ header.sumSalesPrice }}</Cell>
        <Cell th vertical class="price">{{ header.price }}</Cell>
      </tr>
    </template>
    <template #row="{ item: { courseName, rank, rate, sumQty, sumSalesPrice, price }, index }">
      <tr :key="index">
        <Cell horizontal breakWord class="name">{{ toEllipsis(courseName, 50) }}</Cell>
        <Cell>
          <p class="number">{{ numberFormat(rank.number) }}<span class="suffix">位</span></p>
          <div class="diff">
            <p class="last-month">
              前月
              <FluctuationIcon :type="rank.fluctuationType" />
            </p>
            <p>
              (<span class="value">{{ numberFormat(rank.fluctuationValue) }}</span
              >位)
            </p>
          </div>
        </Cell>
        <Cell>
          <p class="number">{{ rateFormat(rate.number) }}<span class="suffix">%</span></p>
          <div class="diff">
            <p class="last-month">
              前月
              <FluctuationIcon :type="rate.fluctuationType" />
            </p>
            <p>
              {{ toOperator(rate.fluctuationType) }}
              <span class="value">{{ rateFormat(rate.fluctuationValue) }}</span
              >%
            </p>
          </div>
        </Cell>
        <Cell>
          <p class="number">{{ numberFormat(sumQty.number) }}<span class="suffix">件</span></p>
          <div class="diff">
            <p class="last-month">
              前月
              <FluctuationIcon :type="sumQty.fluctuationType" />
            </p>
            <p>
              {{ toOperator(sumQty.fluctuationType) }}
              <span class="value">{{ numberFormat(sumQty.fluctuationValue) }}</span
              >件
            </p>
          </div>
        </Cell>
        <Cell>
          <p class="number">{{ numberFormat(sumSalesPrice.number) }}<span class="suffix">円</span></p>
          <div class="diff">
            <p class="last-month">
              前月
              <FluctuationIcon :type="sumSalesPrice.fluctuationType" />
            </p>
            <p>
              {{ toOperator(sumSalesPrice.fluctuationType) }}
              <span class="value">{{ numberFormat(sumSalesPrice.fluctuationValue) }}</span
              >円
            </p>
          </div>
        </Cell>
        <Cell class="price">{{ numberFormat(price) }}<span class="suffix">円</span></Cell>
      </tr>
    </template>
  </StickyTable>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { toEllipsis } from '@/utils/string'
import { numberFormat, rateFormat } from '@/utils/number'
import { toOperator } from '@/utils/analysis'
import StickyTable, { Cell } from '@/components/molecules/StickyTable'
import FluctuationIcon from './FluctuationIcon'

export default {
  name: 'CourseTable',
  components: {
    StickyTable,
    Cell,
    FluctuationIcon,
  },
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState({
      busy: state => state.analysis.courseRanking.busy,
    }),
    ...mapGetters({
      header: 'analysis/courseRanking/header',
      data: 'analysis/courseRanking/data',
    }),
  },
  methods: {
    toOperator,
    toEllipsis,
    numberFormat,
    rateFormat,
  },
}
</script>

<style scoped lang="postcss">
.course-ranking-table {
  max-height: 600px;

  td {
    padding: 8px;
    text-align: right;

    .suffix {
      font-size: 10px;
      margin-left: 2px;
    }

    &.name {
      line-height: 1.3;
      text-align: left;
    }

    .number {
      font-size: 18px;
      font-weight: 600;

      .suffix {
        font-size: 13px;
        margin-left: 2px;
      }
    }

    .diff {
      align-items: center;
      display: flex;
      font-size: 11px;
      justify-content: space-between;

      .last-month {
        align-items: center;
        display: flex;

        svg {
          height: 16px;
          width: 16px;
        }
      }

      .value {
        font-size: 12px;
      }
    }
  }

  .name {
    left: 0;
    width: 30%;
  }

  .price {
    min-width: 72px;
  }
}
</style>
